import React from 'react';
import { motion } from 'framer-motion';
import { BriefcaseIcon, ClockIcon, HeartPulseIcon, HomeIcon, UtensilsIcon, ShoppingBagIcon, StethoscopeIcon, RefreshCwIcon, UsersIcon, LifeBuoyIcon } from 'lucide-react';
import { SectionHeading } from './shared/SectionHeading';
const services = [{
  icon: BriefcaseIcon,
  title: 'Posredovanje pri zapošljavanju',
  desc: 'Povezujemo porodice sa provjerenim njegovateljima i njegovateljicama prema stvarnim potrebama.'
}, {
  icon: ClockIcon,
  title: '24-satna kućna njega',
  desc: 'Organizacija cjelodnevne njege u vlastitom domu, uz stalnu prisutnost i podršku.'
}, {
  icon: HeartPulseIcon,
  title: 'Njega starijih i nemoćnih',
  desc: 'Stručna i topla briga o starijim i nemoćnim osobama uz puno dostojanstva.'
}, {
  icon: HomeIcon,
  title: 'Pomoć u domaćinstvu',
  desc: 'Održavanje čistoće i reda u domu kako bi svakodnevica bila ugodnija.'
}, {
  icon: UtensilsIcon,
  title: 'Priprema obroka',
  desc: 'Priprema zdravih i uravnoteženih obroka prilagođenih potrebama korisnika.'
}, {
  icon: ShoppingBagIcon,
  title: 'Kupovina i nabavka',
  desc: 'Nabavka namirnica, lijekova i svega potrebnog za nesmetan svakodnevni život.'
}, {
  icon: StethoscopeIcon,
  title: 'Pratnja ljekaru',
  desc: 'Sigurna pratnja na preglede, terapije i medicinske kontrole.'
}, {
  icon: RefreshCwIcon,
  title: 'Zamjena njegovatelja',
  desc: 'Brza i pouzdana organizacija zamjene kako njega nikada ne bi bila prekinuta.'
}, {
  icon: UsersIcon,
  title: 'Savjetovanje porodica',
  desc: 'Stručni savjeti i podrška porodicama pri odabiru najbolje vrste njege.'
}, {
  icon: LifeBuoyIcon,
  title: 'Podrška tokom angažmana',
  desc: 'Uz vas smo tokom cijelog trajanja angažmana — od prvog dana do kraja.'
}];
export function Services() {
  return <section id="usluge" className="relative w-full bg-cream py-20 lg:py-28" data-id="element-230">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-231">
        <SectionHeading eyebrow="Naše usluge" title="Premium njega prilagođena vama" subtitle="Sveobuhvatan spektar usluga osmišljen da porodicama pruži mir, a korisnicima kvalitetnu i dostojanstvenu podršku." data-id="element-232" />

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5" data-id="element-233">
          {services.map((s, i) => <motion.article key={s.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: i % 5 * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} whileHover={{
          y: -8
        }} className="group relative flex flex-col rounded-3xl border border-white bg-white p-7 shadow-glass transition-shadow hover:shadow-luxury" data-id="element-234">
              <span className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-cream text-gold ring-1 ring-gold/20 transition-colors group-hover:bg-gold-gradient group-hover:text-white group-hover:ring-transparent" data-id="element-235">
                <s.icon className="h-6 w-6" data-id="element-236" />
              </span>
              <h3 className="font-display text-lg font-bold leading-snug text-ink" data-id="element-237">
                {s.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-238">
                {s.desc}
              </p>
              <span className="mt-5 h-1 w-8 rounded-full bg-gold/30 transition-all duration-300 group-hover:w-14 group-hover:bg-gold" data-id="element-239" />
            </motion.article>)}
        </div>
      </div>
    </section>;
}